export default __webpack_public_path__ + "static/media/productHealthCheckPackage1_all_En.6a0f0c1b.webp";